import React from 'react'
import { func, string } from 'prop-types'
import { Dialog, Illustration, Button } from '@cobalt/cobalt-react-components'
import { ContentHeader } from '../../components'
import { OK } from '../../constants/ui.labels'

const WarningMessage = ({ onClick, title, message, actionMessage }) => {
  return (
    <Dialog>
      <Dialog.Content>
        <Illustration name={Illustration.EXCLAMATION} />
        <ContentHeader title={title} message={message} />
        <Dialog.Actions>
          <Button basic primary onClick={onClick}>
            {actionMessage}
          </Button>
        </Dialog.Actions>
      </Dialog.Content>
    </Dialog>
  )
}

WarningMessage.propTypes = {
  onClick: func.isRequired,
  title: string.isRequired,
  message: string.isRequired,
  actionMessage: string
}

WarningMessage.defaultProps = {
  actionMessage: OK
}

export default WarningMessage
